import type { QueryClient } from "@tanstack/react-query";

export const invalidateTargetQueries = (queryClient: QueryClient, channel?: string) => {
  void queryClient.invalidateQueries({ queryKey: [{ entity: "V4TargetReportByTarget" }] });
  if (channel === "walmart") {
    // Walmart tables still read the legacy datamart report. Its stats query key embeds
    // marketplace/date segments ahead of the endpoint name, so match by contents, not prefix.
    void queryClient.invalidateQueries({
      predicate: (query) => query.queryKey.includes("keyword_report") || query.queryKey.includes("keyword_report_meta"),
    });
  }
};
